import React, { Component } from "react";
import * as actions from "../../actions";

import { FilesPanel } from "./containers/files-panel";
import { FieldsPanel } from "./containers/fields-panel";
import { EventsPanel } from "./containers/events-panel";
import { FieldBoundaryPanel } from "./containers/field-boundary-panel";
import ManagementAreaPanel from "./components/management-area-panel";

import "./import-wizard-panel.css";
import { IImportType } from "~/file-import/model";
import { FieldBoundaryColumns } from "./components/field-boundary-columns";

interface ImportWizardPanelProps {
    panelType: (typeof actions.PanelTypes)[keyof typeof actions.PanelTypes];
    canSubmit?: boolean;
    importAnalysisLayers: boolean;
    updateCanSubmit?: (c: boolean) => void;
    canContinue?: boolean;
    updateCanContinue?: (c: boolean) => void;
    loadDetailPage?: () => void;
    importType: IImportType;
}

export class ImportWizardPanel extends Component<ImportWizardPanelProps> {
    render() {
        const { importType, panelType } = this.props;

        let activePanel = null;
        const fieldsPanelProps = {
            canContinue: this.props.canContinue,
            loadDetailPage: this.props.loadDetailPage,
            updateCanContinue: this.props.updateCanContinue,
        };
        const eventsPanelProps = {
            canSubmit: this.props.canSubmit,
            updateCanSubmit: this.props.updateCanSubmit,
        };
        const fieldBoundaryPanelProps = {
            canSubmit: this.props.canSubmit,
            updateCanSubmit: this.props.updateCanSubmit,
            loadDetailPage: this.props.loadDetailPage,
        };
        const managementAreaPanelProps = {
            canSubmit: this.props.canSubmit,
            updateCanSubmit: this.props.updateCanSubmit,
            importAnalysisLayers: this.props.importAnalysisLayers,
        };

        switch (panelType) {
            case actions.PanelTypes.FILES_PANEL:
                activePanel = (
                    <FilesPanel
                        canContinue={this.props.canContinue}
                        updateCanContinue={this.props.updateCanContinue}
                        loadDetailPage={this.props.loadDetailPage}
                        importType={importType}
                    />
                );
                break;
            case actions.PanelTypes.FIELDS_PANEL:
                activePanel = <FieldsPanel {...fieldsPanelProps} />;
                break;
            case actions.PanelTypes.EVENTS_PANEL:
                activePanel = <EventsPanel {...eventsPanelProps} />;
                break;
            case actions.PanelTypes.FIELD_BOUNDARY_COLUMNS:
                activePanel = (
                    <FieldBoundaryColumns
                        canContinue={this.props.canContinue}
                        updateCanContinue={this.props.updateCanContinue}
                    />
                );
                break;
            case actions.PanelTypes.FIELD_BOUNDARY_PANEL:
                activePanel = <FieldBoundaryPanel {...fieldBoundaryPanelProps} />;
                break;
            case actions.PanelTypes.MANAGEMENT_AREA_PANEL:
                activePanel = <ManagementAreaPanel {...managementAreaPanelProps} />;
                break;
            default:
                break;
        }

        return <div className="import-wizard-panel">{activePanel}</div>;
    }
}
